import {
  getApplicationVersion,
  getApplicationName,
  getEnvironment,
  getArea,
} from "../environmentUtils";

class SDK {
  private static instance: SDK;
  private loaded: boolean = false;
  private zhuge: any;

  private constructor() {}

  // 单例获取方法
  public static getInstance(): SDK {
    if (!SDK.instance) {
      SDK.instance = new SDK();
    }
    return SDK.instance;
  }

  // 初始化方法
  public init(appKey: string, config: object): void {
    if (!this.loaded) {
      this.loadScript()
        .then(() => {
          this.loaded = true;
          if (typeof this.zhuge !== "undefined") {
            this.zhuge._init(appKey, config);
          }
        })
        .catch((error) => {
          console.error("Failed to load SDK script:", error);
        });
    }
  }

  // 动态加载外部脚本的方法
  private loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.getElementById("zhuge-js")) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      const verDate = new Date();
      const verStr = `${verDate.getFullYear()}${verDate.getMonth()}${verDate.getDate()}`;
      script.src = `https://zhuge.starcharge.com/zhuge.js?v=${verStr}`;
      script.id = "zhuge-js";
      script.async = true;

      script.onload = () => {
        this.zhuge = window["zhuge"];
        resolve();
      };
      script.onerror = () => reject(new Error("Failed to load script"));

      document.head.appendChild(script);
    });
  }

  // 事件跟踪方法
  public track(eventName: string, props?: object): void {
    if (this.loaded && this.zhuge) {
      this.zhuge.track(eventName, props);
    } else {
      console.warn("SDK is not loaded. Cannot track event.");
    }
  }

  // 设置用户属性方法
  public async identify(userId: string, extraInfo: object): Promise<void> {
    return new Promise((r) => {
      if (this.loaded && this.zhuge) {
        this.zhuge.identify(userId, extraInfo, r());
      } else {
        console.warn("SDK is not loaded. Cannot set user properties.");
        r();
      }
    });
  }
}
const zhugeInstance = SDK.getInstance();
const init = () => {
  const { DEPLOY_ENV } = process.env;

  if (DEPLOY_ENV === "prod") {
    zhugeInstance.init("7268fcacec1e45909a904b2a98439f30", {
      superProperty: {
        version: getApplicationVersion(),
        environment: getEnvironment(),
        appName: getApplicationName(),
        area: getArea(),
      },
      adTrack: false,
      zgsee: false,
      autoTrack: true,
      singlePage: true,
      // debug:true,
    });
  }
};
init();
// 导出单例实例
export default zhugeInstance;
